/** 
 * 新闻列表模板
 */

import nfItem from './nfItem.vue'
export default nfItem